import { AuthView } from "../types";

interface AuthFormHeaderProps {
  view: AuthView;
}

export const AuthFormHeader = ({ view }: AuthFormHeaderProps) => {
  let title: string;
  let subtitle: string;

  switch (view) {
    case "sign_in":
      title = "Welcome back";
      subtitle = "Sign in to access your AI-powered financial insights";
      break;
    case "sign_up":
      title = "Start Making Smarter Investments";
      subtitle = "7 days premium free • Then free forever • No commitment";
      break;
    case "forgot_password":
      title = "Let's get you back in";
      subtitle = "Enter your email and we'll send you a secure reset link";
      break;
    case "reset_password":
      title = "Almost there";
      subtitle = "Create your new secure password";
      break;
    case "verification_code":
      title = "Check your email";
      subtitle = "We sent a 6-digit code to verify your account";
      break;
    case "confirm_reset_password":
      title = "You're almost back in";
      subtitle = "Just one more step to regain access";
      break;
    default:
      title = "Welcome back";
      subtitle = "Access your financial insights dashboard";
  }

  return (
    <div className="space-y-2 text-center">
      <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-100 to-white bg-clip-text text-transparent drop-shadow-sm leading-tight">{title}</h1>
      {view !== 'sign_up' && (
        <p className="text-xs sm:text-sm text-blue-200/80 max-w-xs mx-auto leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
};
